import { Button, Skeleton } from '@any-ui-react/core';
import { useModals } from '@any-ui-react/modals';
import { v4 as uuid } from 'uuid';

import { PerformanceReviewForm } from './PerformanceReviewForm';

export const CreatePerformanceReview = ({ loading, id }: { loading: boolean; id: string }) => {
  const modalId = uuid();
  const { openModal, closeModal } = useModals();

  const onClick = () => {
    openModal({
      modalId,
      centered: true,
      size: 'md',
      title: 'Which term of the Performance Review would you like to create?',
      children: <PerformanceReviewForm id={id} onClose={() => closeModal(modalId)} />,
    });
  };

  if (loading) {
    return (
      <div className="flex">
        <Skeleton className="m-4 ml-auto" height={32} width={145} />
      </div>
    );
  }

  return (
    <Button className="ml-auto bg-blue-6" onClick={onClick}>
      Create
    </Button>
  );
};
